import React from 'react';
import { useNotify, useQuery } from 'react-admin';
import moment from 'moment';
import { Chip, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import GetAppIcon from '@material-ui/icons/GetApp';
import LoadingIndicator from '../../components/LoadingIndicator';

const statusLabelColours = {
  draft: '#DDECFF',
  open: '#EAE6FF',
  paid: '#00A1A1',
  uncollectible: '#DEE1E5',
  void: '#DEE1E5',
};

const useStyles = makeStyles({
  ellipsis: {
    '&:hover': {
      cursor: 'pointer',
    },
  },
  downloadLink: {
    textDecoration: 'none',
    color: 'inherit',
    '&:hover': {
      cursor: 'pointer',
    },
  },
});

export const Invoices = () => {
  const classes = useStyles();
  const notify = useNotify();
  const {
    data: invoices,
    loading,
    error,
  } = useQuery({
    type: 'getList',
    resource: 'invoices',
    payload: {
      pagination: {},
      sort: {},
      filter: {},
    },
  });

  if (loading) {
    return <LoadingIndicator/>;
  }

  if (error) {
    notify(error.message, 'warning');
    console.error(error);
  }

  return (
    <TableContainer component={Paper}>
      <Table aria-label="List of invoices">
        <TableHead>
          <TableRow>
            <TableCell>Invoice number</TableCell>
            <TableCell align="right">Date of issue</TableCell>
            <TableCell align="right">Currency</TableCell>
            <TableCell align="right">Amount</TableCell>
            <TableCell align="right">Payment deadline</TableCell>
            <TableCell align="right">Status</TableCell>
            <TableCell align="right">
              <GetAppIcon/>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {invoices.map(
            ({
              id,
              number,
              createdAt,
              currency,
              amount,
              dueAt,
              status,
              url,
            }) => (
              <TableRow key={id}>
                <TableCell align="left">{number}</TableCell>
                <TableCell align="right">
                  {moment(createdAt).format('DD/MM/YYYY')}
                </TableCell>
                <TableCell align="right">{currency}</TableCell>
                <TableCell align="right">{(amount / 100).toFixed(2)}</TableCell>
                <TableCell align="right">
                  {dueAt ? moment(dueAt).format('DD/MM/YYYY') : '-'}
                </TableCell>
                <TableCell align="right">
                  <Chip
                    size="small"
                    label={status}
                    style={{
                      backgroundColor: statusLabelColours[status.toLowerCase()],
                      color: '#fff',
                    }}
                  />
                </TableCell>
                <TableCell align="right">
                  <a
                    className={classes.downloadLink}
                    href={url}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Download
                  </a>
                </TableCell>
              </TableRow>
            ),
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
